module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-1__0544874e7664de02b21cd589e6ddf184.png";